'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Paper } from '../Paper/Paper';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { usePopoverContext } from './PopoverContext';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';
import FocusTrap from 'focus-trap-react';
import CloseIcon from '@mui/icons-material/Close';
const transforms = {
    top: 'bottom center',
    'top-start': 'bottom left',
    'top-end': 'bottom right',
    bottom: 'top center',
    'bottom-start': 'top left',
    'bottom-end': 'top right',
    left: 'right center',
    'left-start': 'right top',
    'left-end': 'right bottom',
    right: 'left center',
    'right-start': 'left top',
    'right-end': 'left bottom'
};
const StyledPopoverContent = styled(Popper)({
    zIndex: 1300
});
const getMenuAlignment = (align) => {
    switch (align) {
        case 'end':
            return 'bottom-end';
        case 'center':
            return 'bottom';
        default:
            return 'bottom-start';
    }
};
export const PopoverContent = React.forwardRef(({ children, placement = 'bottom-start', align, flip = true, focusTrapOptions, popperModifiers, PaperProps: paperProps, ...props }, ref) => {
    const resolvedPlacement = align ? getMenuAlignment(align) : placement;
    const { open, anchorRef, handleClose, handleKeyDown, showClose, popoverId } = usePopoverContext('Content');
    let modifiers = [
        {
            name: 'flip',
            enabled: Boolean(flip)
        },
        {
            name: 'offset',
            options: {
                offset: [0, 4]
            }
        }
    ];
    if (popperModifiers) {
        modifiers = modifiers.concat(popperModifiers);
    }
    return (_jsx(StyledPopoverContent, { anchorEl: anchorRef?.current, disablePortal: true, id: popoverId, modifiers: modifiers, open: open, placement: resolvedPlacement, ref: ref, role: 'dialog', transition: true, ...props, children: ({ TransitionProps, placement: childPlacement }) => (_jsx(Grow, { ...TransitionProps, style: {
                transformOrigin: transforms[childPlacement]
            }, children: _jsx(Box, { children: _jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsx(Paper, { borderRadius: 'md', elevation: 8, onKeyDown: handleKeyDown, ...paperProps, children: _jsx(FocusTrap, { active: open, focusTrapOptions: {
                                allowOutsideClick: true,
                                preventScroll: true,
                                ...focusTrapOptions
                            }, children: _jsxs(Box, { children: [showClose && (_jsx(Box, { sx: {
                                            position: 'absolute',
                                            right: '8px',
                                            top: '8px'
                                        }, children: _jsx(IconButton, { "aria-label": 'close', onClick: handleClose, size: 'large', style: {
                                                height: '24px',
                                                width: '24px'
                                            }, children: _jsx(CloseIcon, { fontSize: 'small' }) }) })), children] }) }) }) }) }) })) }));
});
PopoverContent.displayName = 'PopoverContent';
